"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.policyNameCellRenderer = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const components_1 = require("@veeam/components");
const components_2 = require("../../../../components");
const Enable_svg_1 = __importDefault(require("@veeam/uikit-assets/src/icons/common/Enable/Enable.svg"));
const Disable_png_1 = __importDefault(require("@veeam/uikit-assets/src/icons/common/Disable/Disable.png"));
const StyledIcon = styled_components_1.default(components_1.Icon) `
  vertical-align: bottom;
  margin-right: ${({ theme }) => theme.spacing.s};
`;
function policyNameCellRenderer() {
    return function cellRenderer({ cellData, rowData }) {
        const isEnabled = rowData.isEnabled;
        return (react_1.default.createElement(components_2.TruncatedText, null,
            react_1.default.createElement(StyledIcon, { src: isEnabled ? Enable_svg_1.default : Disable_png_1.default }),
            cellData));
    };
}
exports.policyNameCellRenderer = policyNameCellRenderer;
//# sourceMappingURL=policyNameCellRenderer.js.map